import api from '.';

export interface ExerciseAssignmentSession {
  resumable: boolean;
  restartable: boolean;
  isExpired: boolean;
  session?: string;
  result?: {
    amountOfItems: number;
    duration: number;
    score: {
      maximum: number;
      achievable: number;
      achieved: number;
    };
  };
}

export async function getExerciseAssignmentSession(
  moduleId: string,
  assignmentId: string,
): Promise<ExerciseAssignmentSession> {
  const { data } = await api.get<ExerciseAssignmentSession>(
    `/studio/user/modules/${moduleId}/assignments/${assignmentId}/exercise-session`,
  );

  return data;
}
